import React from 'react';

const Loader = () => (
  <div className="grid min-h-screen place-items-center bg-slate-950 text-slate-100">
    <div className="inline-flex flex-col items-center gap-4 rounded-3xl border border-slate-800 bg-slate-900/95 px-8 py-12 shadow-glow">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-cyan-400 border-t-transparent" />
      <p className="text-base text-slate-300">Loading enterprise experience...</p>
    </div>
  </div>
);

export default Loader;
